import { scopedApi } from '@/session/scopedClients';
import { GLOBAL_SCOPE } from '@/session/scopedTransport';
import { EndpointResponse } from '@/types/endpoints';
import { utils } from '../../utils';
import type { WriteRequestOptions } from '../requestOptions';

export type OrganizationCreationData = {
  name: string;
  title: string;
  type?: 'production' | 'sandbox' | 'trial';
  status?: 'active' | 'disabled';
};

export type OrganizationCreationResponse = {
  id: number;
  name: string;
  title: string;
  type?: string;
  status: string;
  created_at: string;
};

type RequestParams = {
  data: OrganizationCreationData;
};

// Organization creation is authenticated-global (the new tenant does not
// exist yet), so the operation owns GLOBAL_SCOPE (globalEndpoints convention).
export const createOrganization = async (
  { data }: RequestParams,
  options: WriteRequestOptions
): Promise<EndpointResponse<OrganizationCreationResponse>> => {
  try {
    const response = await scopedApi(GLOBAL_SCOPE).post<EndpointResponse<OrganizationCreationResponse>>('/organization', data, options);
    return response.data;
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
